import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../../model/rodeo';
import { ProgressionTieBreaker } from '../../../../../model/progression-tiebreaker';

@Component({
    selector: 'progression-tiebreaker',
    templateUrl: 'progression-tiebreaker.html'
})
export class ProgressionTieBreakerModal {
    rodeo: Rodeo;
    tieBreaker: ProgressionTieBreaker;
    editing: boolean = true;
    isRoughStock: boolean = false;

    rounds: any[];

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeo = navParams.get('rodeo');
        this.tieBreaker = navParams.get('tieBreaker');

        if (!this.tieBreaker) {
            this.tieBreaker = new ProgressionTieBreaker();
            this.editing = false;
        } else {
            this.tieBreaker.payoutConfig = null;
            this.tieBreaker.pointSeries = null;
            this.tieBreaker = JSON.parse(JSON.stringify(this.tieBreaker));
        }

        this.updatePayoutConfig();
    }

    changeBreakByTimeScore() {
        if (this.tieBreaker.breakByTimeScore) {
            this.tieBreaker.breakByTotalTimeScore = false;
            this.tieBreaker.breakByPointSeriesPlace = false;
            this.tieBreaker.breakByAthleteScore = false;
            this.tieBreaker.breakByCombinedAthleteScore = false;
            this.tieBreaker.breakByRideTime = false;
        }
    }

    changeBreakByTotalTimeScore() {
        if (this.tieBreaker.breakByTotalTimeScore) {
            this.tieBreaker.breakByTimeScore = false;
            this.tieBreaker.breakByPointSeriesPlace = false;
            this.tieBreaker.breakByAthleteScore = false;
            this.tieBreaker.breakByCombinedAthleteScore = false;
            this.tieBreaker.breakByRideTime = false;
        }
    }

    changeBreakByPointSeriesPlace() {
        if (this.tieBreaker.breakByPointSeriesPlace) {
            this.tieBreaker.breakByTotalTimeScore = false;
            this.tieBreaker.breakByTimeScore = false;
            this.tieBreaker.breakByAthleteScore = false;
            this.tieBreaker.breakByCombinedAthleteScore = false;
            this.tieBreaker.breakByRideTime = false;
        }
    }

    changeBreakBySingleRideScore() {
        if (this.tieBreaker.breakByAthleteScore) {
            this.tieBreaker.breakByTotalTimeScore = false;
            this.tieBreaker.breakByTimeScore = false;
            this.tieBreaker.breakByPointSeriesPlace = false;
            this.tieBreaker.breakByCombinedAthleteScore = false;
            this.tieBreaker.breakByRideTime = false;
        }
    }

    changeBreakByCombinedAthleteScore() {
        if (this.tieBreaker.breakByCombinedAthleteScore) {
            this.tieBreaker.breakByTotalTimeScore = false;
            this.tieBreaker.breakByTimeScore = false;
            this.tieBreaker.breakByPointSeriesPlace = false;
            this.tieBreaker.breakByAthleteScore = false;
            this.tieBreaker.breakByRideTime = false;
        }
    }
    changeBreakByRideTime() {
        if (this.tieBreaker.breakByRideTime) {
            this.tieBreaker.breakByTotalTimeScore = false;
            this.tieBreaker.breakByTimeScore = false;
            this.tieBreaker.breakByPointSeriesPlace = false;
            this.tieBreaker.breakByCombinedAthleteScore = false;
            this.tieBreaker.breakByAthleteScore = false;
        }
    }

    updatePayoutConfig() {
        this.isRoughStock = false;

        if (this.tieBreaker.payoutConfigId) {
            const payoutConfig = this.rodeo.payoutConfigs.filter(x => x.id == this.tieBreaker.payoutConfigId)[0];
            payoutConfig.sources.forEach(source => {
                const matchingClass = this.rodeo.rodeoEvents.filter(x => x.id == source.rodeoEventId)[0];

                if (matchingClass.eventType === 'BullRiding' || matchingClass.eventType === 'SaddleBroncRiding' || matchingClass.eventType === 'RanchBroncRiding' || matchingClass.eventType === 'BarebackRiding') {
                    this.isRoughStock = true;
                    return;
                }
            })
        }
    }

    create() {
        if (this.tieBreaker.breakByPointSeriesPlace)
            this.tieBreaker.pointSeriesId = 1;

        this.viewController.dismiss(this.tieBreaker);
    }

    remove() {
        this.viewController.dismiss(0);
    }

    cancel() {
        this.viewController.dismiss(null);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/progressions/progression-tiebreaker.ts